
<div class="container-fluid" [style.display]="this.fileupload.enabled === undefined || (activeElements && activeElements[this.fileupload?.enabled]) ? 'block' : 'none'">
  <div class="row-md-4">
    <div class="col-md-12 mt-1">
      @if (fileupload.type==='upload' && !documentSection && !uploadDisabled) {
        <label class="col-sm-3 col-form-label" for="files">
          @if (fileupload.title) {
            <span>{{fileupload.title}}</span>
          }
          {{'FILE-UPLOAD.ATTACHMENTS' | translate}}
          @if (fileupload.mandatory && !fileupload.value) {
            <span style="color:crimson;">*</span>
          }
        </label>
      }
      @if (this.fileupload.value) {
        <div class="row mb-3">
          @if (fileupload.format) {
            <div style="margin-top: 0.5rem;  max-width: 750px;">{{fileupload.type==='upload'?fileupload.value.fileName:fileupload.title}}</div>
            @for (format of fileupload.format; track format) {
              <div class="col-1">
                <button type="button" class="btn btn-outline-primary btn-xs"
                             (click)="fileupload.type==='file-static'?
                             downloadFile(fileupload.value.key, fileupload.value.fileName):
                            downloadAssetFile(fileupload.type, fileupload.value.key, fileupload.value.fileName, format)">
                  <span class="glyphicon glyphicon-trash"></span>
                  <div style="display: inline-grid;">
                    <div>{{format}}</div>
                    @if (downloading[format]) {
                      <div class="loader center"></div>
                    }
                    @if (fileError[format]) {
                      <div style="color:crimson;">File Error</div>
                    }
                  </div>
                </button>
                @if (fileupload.type==='upload') {
                  <button  type="button" class="btn btn-danger btn-xs" (click)="openModalDelete(templateDelete, fileupload.value.key, 'DELETE_FILE')">
                    <span class="glyphicon glyphicon-trash"></span>
                    <lucide-icon name="trash-2" ngbTooltip="delete" size="16"></lucide-icon>
                  </button>
                }
              </div>
            }
          }
          @if (!fileupload.format) {
            <div style="margin-top: 0.5rem; max-width: 750px;">{{fileupload.type==='upload' && !documentSection? fileupload.value.fileName:((fileupload.title?fileupload.title:'')+(fileupload.title&&fileupload.value.fileName?": ":"")+(fileupload.value.fileName))}}</div>
            <div class="col">
              <button  type="button" class="btn btn-outline-primary btn-xs"
                             (click)="fileupload.type==='file-static' || fileupload.type==='upload'?
                             downloadFile(fileupload.value.key, fileupload.value.fileName):
                            downloadAssetFile(fileupload.type, fileupload.value.key, fileupload.value.fileName, null)">
                <span class="glyphicon glyphicon-trash"></span>
                <div style="display: inline-grid;">
                  <div>{{fileupload.value.fileName.substr(fileupload.value.fileName.lastIndexOf(".")+1, fileupload.value.fileName.length)}}</div>
                  @if (downloading) {
                    <div class="loader center"></div>
                  }
                  @if (fileError) {
                    <div style="color:crimson;">File Error</div>
                  }
                </div>
              </button>
              @if (fileupload.type==='upload') {
                <button  type="button" class="btn btn-danger btn-xs" (click)="openModalDelete(templateDelete, fileupload.value.key, 'DELETE_FILE')">
                  <span class="glyphicon glyphicon-trash"></span>
                  <lucide-icon name="trash-2" ngbTooltip="delete" size="16"></lucide-icon>
                </button>
              }
            </div>
          }
        </div>
      }
      @if (fileupload.type==='upload' && !uploadDisabled && !(this.uploader.queue.length===0 && fileupload.value!==undefined && fileupload.value!==null)) {
        <table class="table" style="display: none;">
          <thead>
            <tr>
              <th>{{'FILE-UPLOAD.NAME' | translate}}</th>
              <th>{{'FILE-UPLOAD.SIZE' | translate}}</th>
              <th>{{'FILE-UPLOAD.ACTION' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of uploader.queue; track item) {
              <tr>
                <td>
                  {{ item?.file?.name }}
                </td>
                <td>
                  {{ item?.file?.size/1024/1024 | number:'.2' }} MB
                </td>
                <td>
                  <button type="button" class="btn btn-danger btn-xs" (click)="item.remove()">
                    <span class="glyphicon glyphicon-trash"></span>
                    {{'FILE-UPLOAD.REMOVE_FILE' | translate}}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }

    </div>
    @if (fileupload.type==='upload' && !uploadDisabled && !(this.uploader.queue.length===0 && fileupload.value!==undefined && fileupload.value!==null)) {
      <div class="col-md-12">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-9">
              <span class="hidden-file">
                <input type="file" name="file" #fileInput ng2FileSelect [uploader]="uploader"
                  (onFileSelected)="onFileSelected($event)" style="display: none;" />
                </span>
                @if (documentSection) {
                  <input style="width: 300px; margin-right:10px;" type="text" class="form-control" placeholder="{{'UPLOAD.NAME' | translate }}" name="name" [(ngModel)]="fileupload.title">
                  }<br/>
                  <div class="btn-group" (click)="fileInput.click()" style="display: inline;">
                            <button type="button" class="btn btn-primary" [disabled]="this.uploader.queue.length>0
                                    || (this.uploader.queue.length===0 && fileupload.value!==undefined && fileupload.value!==null)" >
                      {{'FILE-UPLOAD.UPLOAD_FILE' | translate}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <ng-template #templateDelete>
      <div class="modal-body text-center">
        <p>{{'CONTROL-MODULE.'+actionText | translate}}</p>
        <button type="button" class="btn btn-outline-secondary"
          (click)="confirm()">{{'CONTROL-MODULE.YES' |
        translate}}</button>
        <button type="button" class="btn btn-primary" (click)="modalDeleteRef?.hide()">{{'CONTROL-MODULE.CANCEL' | translate}}</button>
      </div>
    </ng-template>


    <ngx-spinner bdColor="rgba(0,0,0,0.8)" size="medium" color="var(--fg-on-navy)" type="ball-scale-multiple">
      <p style="font-size: 20px; color: white; text-align: center;">{{'UTIL.DOWNLOADING' | translate}}...</p>
    </ngx-spinner>
